import { useEffect, useRef } from "react";
import api, { setToken } from "@/lib/api";

export default function AuthCallback() {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (sessionId) {
        try {
          const { data } = await api.post("/auth/session", { session_id: sessionId });
          setToken(data.token);
        } catch (e) {
          window.location.href = "/login";
          return;
        }
      }
      window.history.replaceState(null, "", "/dashboard");
      window.location.href = "/dashboard";
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground font-mono text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
